module.exports = __webpack_public_path__ + "img/w5-b3.5d449ad3.jpg";